export enum RecoveryKeys {
    RecoveredSuccessfully = "RecoveredSuccessfully",
    RecoveryFailureReason = "RecoveryFailureReason",
    RecoveredAudioLengthSeconds = "RecoveredAudioLengthSeconds"
};